import { Component, ElementRef, Input, OnInit, forwardRef } from '@angular/core';
import { CountryISO, NgxIntlTelInputComponent, PhoneNumberFormat, SearchCountryField } from '@scr/ngx-intl-tel-input';
import { CountryCode } from './country-code';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import libphonenumber from 'google-libphonenumber';
import { Country } from '@scr/ngx-intl-tel-input/lib/model/country.model';
import scrollIntoView from 'scroll-into-view-if-needed';



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const phoneNumberValidator = (control: any) => {
	if (!control.value) {
		return;
	}
	// Find <input> inside injected nativeElement and get its "id".
	const el: HTMLElement = control.nativeElement as HTMLElement;
	const inputBox: HTMLInputElement | undefined = el
		? el.querySelector('input[type="tel"]') as HTMLInputElement
		: undefined;
	if (inputBox) {
		const isCheckValidation = inputBox.getAttribute('validation');
		if (isCheckValidation === 'true') {
			const isRequired = control.errors && control.errors.required === true;
			const error = { validatePhoneNumber: { valid: false } };

			inputBox.setCustomValidity('Invalid field.');

			let number: libphonenumber.PhoneNumber | undefined = undefined;

			try {
				number = libphonenumber.PhoneNumberUtil.getInstance().parse(
					control.value.number,
					control.value.countryCode
				);
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			} catch (e) {
				if (isRequired) {
					return error;
				} else {
					inputBox.setCustomValidity('');
				}
			}

			if (control.value) {
				if (!number) {
					return error;
				} else {
					if (
						!libphonenumber.PhoneNumberUtil.getInstance().isValidNumberForRegion(
							number,
							control.value.countryCode
						)
					) {
						return error;
					} else {
						inputBox.setCustomValidity('');
					}
				}
			}
		} else if (isCheckValidation === 'false') {
			inputBox.setCustomValidity('');

			control.clearValidators();
		}
	}
	return;
};

@Component({
	selector: 'app-phone',
	templateUrl: './phone.component.html',
	styleUrls: ['./bootstrap-dropdown.css', './phone.component.css'],
	providers: [
		CountryCode,
		BsDropdownDirective,
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PhoneComponent),
			multi: true,
		},
		{
			provide: NG_VALIDATORS,
			useValue: phoneNumberValidator,
			multi: true,
		},
	],

})

export class PhoneComponent extends NgxIntlTelInputComponent implements OnInit {

	@Input() id!: string | undefined;

	constructor(private el: ElementRef, cc: CountryCode) {
		super(cc);


		this.maxLength = 20;
		this.phoneValidation = true;
		this.searchCountryFlag = true;
		this.searchCountryField = [SearchCountryField.All];
		this.numberFormat = PhoneNumberFormat.International;
		this.preferredCountries = [CountryISO.UnitedStates];
		if (el.nativeElement.id) {
			// don't set input id.  You get duplication.
			// this.inputId = el.nativeElement.id;
			if (!el.nativeElement.name) {
				el.nativeElement.name = el.nativeElement.id;
			}
		}
	}

	override ngOnInit(): void {
		super.ngOnInit();

		//console.debug('super inputId ' + this.inputId);
		//console.debug('this id ' + this.id);
		// parent control sets the input id to 'phone'.  If set to that and we have an ID, use it.
		if (this.inputId === 'phone' && this.id) {
			this.inputId = `${this.id}Input`;
			// console.debug('override input id to be id plus input => ' + this.inputId);
		}
	}

	hasBeenShown(): void {
		setTimeout(() => {
			const elem = this.el.nativeElement.querySelector('.dropdown-menu');
			if (elem.scrollIntoViewIfNeeded) {
				elem.scrollIntoViewIfNeeded(false);
			}
			else {
				scrollIntoView(elem, { scrollMode: 'if-needed', block: 'nearest', inline: 'nearest' });
			}
			const el = this.findDecedentWithId(elem, 'country-search-box');
			if (el) {
				(el as HTMLInputElement).focus();
			}

		}, 100);
	}

	override onPhoneNumberChange(): void {
		super.onPhoneNumberChange();
		// there is a bug that changes the sort of the
		// allCountries array when the automatic country
		// recognition is on.  Resort it after.
		this.allCountries.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
	}

	override onCountrySelect(country: Country, el: { focus: () => void; }): void {
		super.onCountrySelect(country, el);

		// try to clean the dropdown.
		const e = this.el.nativeElement as Element;
		const ee = this.findDecedentWithId(e, 'country-search-box') as HTMLInputElement;
		if (ee) {
			ee.value = "";
		}

	}

	private findDecedentWithId(e: Element, name: string, tagName?: string): Element | undefined {
		if (e.id === name && (!tagName || (e.tagName === tagName))) {
			return e;
		}

		for (let i = 0; i < e.children.length; i++) {
			const c = e.children.item(i);
			if (c) {
				const match = this.findDecedentWithId(c, name);
				if (match) {
					return match;
				}
			}
		}
		return undefined;
	}
}

